var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.rootDialogParams)?_c('FinderDialog',_vm._b({key:_vm.rootDialogKey,attrs:{"visible":_vm.isRootDialogShow},on:{"update:visible":function($event){_vm.isRootDialogShow=$event}}},'FinderDialog',_vm.rootDialogParams,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }